import React from "react"
import { Outlet } from "react-router-dom"
// import GuestHeader from "layoutsV2/client/GuestHeader"
import UnactiveGuideMessage from "components/common/UnactiveGuideMessage"
import withDefaultErrorBoundary from "modules/errors/HOCs/withDefaultErrorBoundary"
import DefaultErrorBoundary from "modules/errors/DefaultErrorBoundary"
import Header from "components/layout/Header"
import styles from "./index.module.css"

function DashboardLayout() {
  return (
    <main className={`vstack min-vh-100 bg-light ${styles.guestDashboardLayout}`}>
      {/* <GuestHeader withNavigation /> */}
      <Header />
      <div className={`flex-fill vstack min-h-100 py-15 px-80 ${styles.dashboardLayout}`}>
        <UnactiveGuideMessage>
          <DefaultErrorBoundary>
            <Outlet />
          </DefaultErrorBoundary>
        </UnactiveGuideMessage>
      </div>
    </main>
  )
}

export default withDefaultErrorBoundary(DashboardLayout)
